import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateCompanyAccountingDetailsRequest extends BaseUpdateRequest {
    externalAccountingSystemId: string;
}